module.exports = __webpack_public_path__ + "static/img/rank_232.e3daab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_232.png
// module id = 9AfG
// module chunks = 0